module.exports = __webpack_public_path__ + "static/media/13.9f08f2e2.jpg";